import script from "./TiptapSnippet.vue?vue&type=script&setup=true&lang=js"
export * from "./TiptapSnippet.vue?vue&type=script&setup=true&lang=js"

import "./TiptapSnippet.vue?vue&type=style&index=0&id=5fdbdf15&lang=css"

const __exports__ = script;

export default __exports__